import { createSelector } from 'reselect';
import Constants from './constants';
import { UploadUserListStages } from '../../../Pages/Users/constants';

const STATE_KEY_NAME = Constants.MODULE_NAME;

const stateSelector = (state) => state[STATE_KEY_NAME];

const orgUsersSelector = createSelector(stateSelector, (state) => {
  return state.orgUsers;
});

const teamsSelector = createSelector(stateSelector, (state) => {
  return state.teams;
});

const usersDataSelector = createSelector(stateSelector, (state) => {
  return state.usersData;
});

const modalErrorSelector = createSelector(stateSelector, (state) => state.modalError);

const modalErrorMessageSelector = createSelector(stateSelector, (state) => state.modalErrorMessage);

const addUserModalSelector = createSelector(stateSelector, (state) => state.modals.addUserModalOpen);

const disableTeamManagementModalSelector = createSelector(
  stateSelector,
  (state) => state.modals.disableTeamManagementModalOpen,
);

const updateProfileModalSelector = createSelector(stateSelector, (state) => state.modals.editProfileModalOpen);

const removeUserModalSelector = createSelector(stateSelector, (state) => state.modals.removeUserModalOpen);
const removeMultipleUsersModalSelector = createSelector(
  stateSelector,
  (state) => state.modals.removeMultipleUsersModalOpen,
);

const resendInviteModalSelector = createSelector(stateSelector, (state) => state.modals.resendInviteModalOpen);

const removeInviteModalSelector = createSelector(stateSelector, (state) => state.modals.removeInviteModalOpen);
const resetPasswordModalSelector = createSelector(stateSelector, (state) => state.modals.resetPasswordModalOpen);
const multiAssignModelSelector = createSelector(stateSelector, (state) => state.modals.multiAssignModalOpen);
const sendRemindersModalSelector = createSelector(stateSelector, (state) => state.modals.sendRemindersModalOpen);

const updatePermissionsModalSelector = createSelector(
  stateSelector,
  (state) => state.modals.updatePermissionsModalOpen,
);

const assignToTeamsModalSelector = createSelector(stateSelector, (state) => state.modals.assignToTeamsModalOpen);
const bulkAssignToTeamsModalSelector = createSelector(
  stateSelector,
  (state) => state.modals.bulkAssignToTeamsModalOpen,
);

const renameTeamModalSelector = createSelector(stateSelector, (state) => state.modals.renameTeamModalOpen);
const deleteTeamModalSelector = createSelector(stateSelector, (state) => state.modals.deleteTeamModalOpen);
const createTeamModalSelector = createSelector(stateSelector, (state) => state.modals.createTeamModalOpen);

const userFilterSelector = createSelector(stateSelector, (state) => state.filterText);

const permissionFilterSelector = createSelector(stateSelector, (state) => state.filterPermissions);

const statusFilterSelector = createSelector(stateSelector, (state) => state.filterStatus);

const teamsFilterSelector = createSelector(stateSelector, (state) => state.filterTeams);

const totalUserCountSelector = createSelector(stateSelector, (state) => state.totalUsers);

const totalAdminCountSelector = createSelector(stateSelector, (state) => state.totalAdmins);

const currentClickedUserSelector = createSelector(stateSelector, (state) => state.currentClickedUser);

const remindersToSendSelector = createSelector(stateSelector, (state) => state.remindersToSend);

const exportIsLoadingSelector = createSelector(stateSelector, (state) => state.exportIsLoading);

const exportAuditIsLoadingSelector = createSelector(stateSelector, (state) => state.exportAuditIsLoading);

const isLoadingUsersSelector = createSelector(stateSelector, (state) => state.isLoadingUsers);

const isLoadingInvitesSelector = createSelector(stateSelector, (state) => state.isLoadingInvites);

const isLoadingSummarySelector = createSelector(stateSelector, (state) => state.isLoadingSummary);

const isLoadingCheckEmailSelector = createSelector(stateSelector, (state) => state.isLoadingCheckEmail);

const isLoadingPermissionsSelector = createSelector(stateSelector, (state) => state.isLoadingPermissions);
const isLoadingRemindersSelector = createSelector(stateSelector, (state) => state.isLoadingReminders);

const isUserListNoticeShowSelector = createSelector(stateSelector, (state) => state.isUserListPendingShowing);

const uploadUsersListStageSelector = createSelector(
  stateSelector,
  (state) => state.uploadMultiUsers.uploadUsersListStage,
);
const isLoadingUploadingUsersSelector = createSelector(stateSelector, (state) => state.isLoadingUploadingUsers);
const validUsersInUploadSelector = createSelector(stateSelector, (state) => state.uploadMultiUsers.validUsersInUpload);
const existingUsersInUploadSelector = createSelector(
  stateSelector,
  (state) => state.uploadMultiUsers.existingUsersInUpload,
);
const invalidUsersInUploadSelector = createSelector(
  stateSelector,
  (state) => state.uploadMultiUsers.invalidUsersInUpload,
);
const usersUploadProgressSelector = createSelector(
  stateSelector,
  (state) => state.uploadMultiUsers.usersUploadProgress,
);
const reportListSelector = createSelector(stateSelector, (state) => state.uploadMultiUsers.reportList);
const usersToBeSubscribedSelector = createSelector(
  stateSelector,
  (state) => state.uploadMultiUsers.usersToBeSubscribed,
);
const isUploadUsersListInProgressSelector = createSelector(
  stateSelector,
  (state) => state.uploadMultiUsers.uploadUsersListStage === UploadUserListStages.PROGRESS_BAR,
);

const availableSubscriptionsSelector = createSelector(stateSelector, (state) => {
  return (
    state.usersData?.search_status?.subscriptions_count -
    state.orgUsers.filter((user) => user.assigned_to_search)?.length
  );
});
const totalSubscriptionSelector = createSelector(stateSelector, (state) => {
  return state.usersData?.search_status?.subscriptions_count;
});

const isTrialSelector = createSelector(stateSelector, (state) => {
  return state.usersData?.search_status?.is_in_trial;
});

export const UsersSelectors = {
  isLoadingSummarySelector,
  isLoadingInvitesSelector,
  isLoadingUsersSelector,
  isLoadingRemindersSelector,
  isLoadingUploadingUsersSelector,
  exportIsLoadingSelector,
  exportAuditIsLoadingSelector,
  currentClickedUserSelector,
  userFilterSelector,
  permissionFilterSelector,
  statusFilterSelector,
  teamsFilterSelector,

  totalAdminCountSelector,
  totalUserCountSelector,

  orgUsersSelector,

  modalErrorSelector,
  modalErrorMessageSelector,
  addUserModalSelector,
  disableTeamManagementModalSelector,
  sendRemindersModalSelector,
  updateProfileModalSelector,
  removeUserModalSelector,
  removeMultipleUsersModalSelector,
  resetPasswordModalSelector,
  multiAssignModelSelector,
  renameTeamModalSelector,
  deleteTeamModalSelector,
  createTeamModalSelector,
  removeInviteModalSelector,
  updatePermissionsModalSelector,
  assignToTeamsModalSelector,
  bulkAssignToTeamsModalSelector,
  resendInviteModalSelector,

  usersDataSelector,
  isLoadingCheckEmailSelector,
  isLoadingPermissionsSelector,
  isUserListNoticeShowSelector,
  remindersToSendSelector,
  teamsSelector,
  uploadUsersListStageSelector,

  validUsersInUploadSelector,
  existingUsersInUploadSelector,
  invalidUsersInUploadSelector,
  usersUploadProgressSelector,
  reportListSelector,
  usersToBeSubscribedSelector,
  isUploadUsersListInProgressSelector,
  availableSubscriptionsSelector,
  totalSubscriptionSelector,
  isTrialSelector,
};
